import React from "react";
import { toLocale } from "@bonliva-crm/locale";
import { Body } from "./Body";

type Props = {
  value: number;
  currency: string;
};

export function Currency(props: Props) {
  return (
    <Body nobr>
      {toLocale.currencyDecimal(props.value)}{" "}
      <span style={{ color: "#898989" }}>{props.currency}</span>
    </Body>
  );
}
